import {
	LinkButton,
	Icon,
	// GridCell
} from 'ui/components';
import styles from './Newsletter.module.scss';
import Corp from 'ui/icons/icon-corp-brand-secondary.svg';
export interface NewsletterProps {
	emailLabel?: string;
	moduleLink?: Umbraco.Link;
	hideCorp?: boolean;
}

export const Newsletter: React.FC<NewsletterProps> = ({
	// emailLabel,
	moduleLink,
	hideCorp = false,
}) => {
	return (
		// <GridCell mobileWidth="100" desktopWidth="33">
		<article className={styles.NewsLetter}>
			{/* <p className={styles.Newsletter_label}>{emailLabel}</p> */}
			{!hideCorp && (
				<Icon className={styles.NewsLetter_corp}>
					<Corp />
				</Icon>
			)}

			<LinkButton
				className={styles.Newsletter_link}
				url={moduleLink?.url}
				style="primary"
			>
				{moduleLink?.name}
			</LinkButton>
		</article>
		// </GridCell>
	);
};
